import * as date_function from "@/unity/date_function.js";

export default {
  ...date_function,
};
